import { render, staticRenderFns } from "./editNewsItem.vue?vue&type=template&id=2e6dc0f2&scoped=true&"
import script from "./editNewsItem.vue?vue&type=script&lang=js&"
export * from "./editNewsItem.vue?vue&type=script&lang=js&"
import style0 from "./editNewsItem.vue?vue&type=style&index=0&id=2e6dc0f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6dc0f2",
  null
  
)

export default component.exports